export default "__VITE_ASSET__BWvqCrnj__"